import { constantRouterMap, registerComponentMap } from '@/router/index';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(rolesMap, route) {

    if (rolesMap[route.key]) {
        return true
    }
    return false
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(registerComponentMap, roles) {
    const accessedRouters = registerComponentMap.filter(route => {
        const rolesMap = {}
        roles.forEach(function(currentValue) {
            rolesMap[currentValue.url] = currentValue;
        })
        if (hasPermission(rolesMap, route)) {

            if(route.noDropdown){
                route.name = rolesMap[route.key].name;
                route.icon = rolesMap[route.key].iconUrl;
                route.path = '/' + rolesMap[route.key].url;
                route.redirect = '/children_'+rolesMap[route.key].url;
                route.children = [{ path: 'children_'+rolesMap[route.key].url,name:rolesMap[route.key].name,isShow: true,parent: false, component: route.childrenComponent }];
                delete route.childrenComponent;
            }else{
                // 组装权限
                if (route.parent) {
                    route.path = '/' + rolesMap[route.key].url;
                    route.redirect = 'noredirect';
                }else{
                    route.path = rolesMap[route.key].url;
                }
                route.name = rolesMap[route.key].name;
                route.icon = rolesMap[route.key].iconUrl;
                if(rolesMap[route.key].view===1){
                    route.isShow = true
                }else{
                    route.isShow = false
                }
                if (route.children && route.children.length) {
                    route.children = filterAsyncRouter(route.children, roles)
                }
            }
            return true
        }
        return false
    })

    return accessedRouters
}

const permission = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        routerStatus: false
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers);
        },
        SET_ROUTER_STATUS: (state, status) => {
            state.routerStatus = status;
        }
    },
    actions: {
        GenerateRoutes({ commit }, data) {
            return new Promise(resolve => {
                const { roles } = data;
                // 判断权限
                const accessedRouters = filterAsyncRouter(registerComponentMap, roles);
                // 提交action
                commit('SET_ROUTERS', accessedRouters);
                commit('SET_ROUTER_STATUS', true);
                resolve();
            })
        },
        ResetRouterStatus({ commit }, data) {
            return new Promise(resolve => {
                commit('SET_ROUTERS', []);
                commit('SET_ROUTER_STATUS', data);
                resolve();
            })
        }
    }
};

export default permission;



// WEBPACK FOOTER //
// ./src/store/modules/permission.js